import YearSection from "./YearSection";
import { getChoreographyDataByYear } from "../utils/choreographyRoutes";

function IndexPage() {
  // Get choreography data organized by year
  const choreographyData = getChoreographyDataByYear();

  return (
    <div style={{ fontFamily: "Arial, sans-serif" }}>
      <header
        style={{
          textAlign: "center",
          marginBottom: "40px",
          background: "#424242",
          padding: "clamp(30px, 8vw, 60px) clamp(20px, 5vw, 40px)",
          position: "relative",
          overflow: "hidden",
          width: "100%",
        }}
      >
        <h1
          style={{
            color: "#ffffff",
            marginBottom: "15px",
            fontSize: "clamp(2rem, 6vw, 3rem)",
            fontWeight: "700",
            position: "relative",
          }}
        >
          Choreos
        </h1>
        <p
          style={{
            color: "#e0e0e0",
            fontSize: "clamp(1rem, 3vw, 1.3rem)",
            fontWeight: "400",
            position: "relative",
            maxWidth: "600px",
            margin: "0 auto",
            padding: "0 10px",
          }}
        >
          Select a choreography to view and analyze
        </p>
      </header>

      <div
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          padding: "0 20px 40px 20px",
        }}
      >
        <main>
          <h2
            style={{ color: "#333", marginBottom: "20px", fontSize: "1.8rem" }}
          >
            Choreographies
          </h2>

          {Object.entries(choreographyData)
            .sort(([yearA], [yearB]) => parseInt(yearB) - parseInt(yearA))
            .map(([year, choreographies]) => (
              <YearSection
                key={year}
                year={year}
                choreographies={choreographies}
              />
            ))}
        </main>
      </div>
    </div>
  );
}

export default IndexPage;
